import React, { Component } from 'react';
import styled from 'styled-components';

import { PageBaseLayout, PageDescription } from '../../..';
import { getData, BreadTreeElement } from '../../../../utils/PageApi';
import { buttonText } from '../../../../constants/buttonText';
import { BottomSectionText } from '../../../../constants/BottomSectionText';
import colors from '../../../colors';
import VisaCollectionBox from './VisaCollectionBox';
import { media } from '../../../../utils/Helper';

const MainSectionDiv = styled.div`
  background-color: ${colors.lightGray};
  margin-right: calc(((100vw - 100%) / 2) * -1);
  margin-left: calc(((100vw - 100%) / 2) * -1);
  padding: 80px 7.5rem;
  ${media.tablet`
  padding: 2.4rem 1.6rem;
  `}
`;
const FlexDiv = styled.div`
  display: flex;
  ${media.tablet`
  flex-direction: column;
  `}
  max-width: 1200px;
  margin: 0 auto;
`;
const CollectionDiv = styled.div`
  margin: 0 0.8rem;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  width: 50%;
  ${media.tablet`
  width: 100%;
  margin: 0rem;
  `}
`;

type PageDataType = {
  title: { rendered: string };
  link: string;
  featured_media: number;
  acf: {
    metaDescription: string;
    heroImg: string;
    subtitle: string;
    pageDescription: string;
    visaTitle: string;
    visaTitle1: string;
    visaText1: string;
    visaTitle2: string;
    visaText2: string;
    visaTitle3: string;
    visaText3: string;
    permitTitle: string;
    permitTitle1: string;
    permitText1: string;
    permitTitle2: string;
    permitText2: string;
    permitTitle3: string;
    permitText3: string;
    permitTitle4: string;
    permitText4: string;
    permitTitle5: string;
    permitText5: string;
    permitTitle6: string;
    permitText6: string;
    permitTitle7: string;
    permitText7: string;
    permitTitle8: string;
    permitText8: string;
  };
  slug: string;
  parent: number;
};
interface OwnProps {}
interface OwnState {
  data: PageDataType;
  breadTreeElements: BreadTreeElement[];
}

class VisaCollection extends Component<OwnProps, OwnState> {
  constructor(ownProps: any, ownState: any) {
    super(ownProps, ownState);
    this.state = {
      data: {
        title: { rendered: '' },
        link: '',
        featured_media: 0,
        acf: {
          metaDescription: '',
          heroImg: '',
          subtitle: '',
          pageDescription: '',
          visaTitle: '',
          visaTitle1: '',
          visaText1: '',
          visaTitle2: '',
          visaText2: '',
          visaTitle3: '',
          visaText3: '',
          permitTitle: '',
          permitTitle1: '',
          permitText1: '',
          permitTitle2: '',
          permitText2: '',
          permitTitle3: '',
          permitText3: '',
          permitTitle4: '',
          permitText4: '',
          permitTitle5: '',
          permitText5: '',
          permitTitle6: '',
          permitText6: '',
          permitTitle7: '',
          permitText7: '',
          permitTitle8: '',
          permitText8: '',
        },
        slug: '',
        parent: 0,
      },
      breadTreeElements: [],
    };
  }

  async createData() {
    let pageId = 589;
    const state = await getData<PageDataType>(pageId);
    this.setState(state);
  }
  componentDidMount() {
    this.createData();
  }

  render() {
    let data = this.state.data;
    let dataAcf = data.acf;
    let title = data.title.rendered;

    let visaCollection = [
      {
        title: dataAcf.visaTitle1,
        text: dataAcf.visaText1,
      },
      {
        title: dataAcf.visaTitle2,
        text: dataAcf.visaText2,
      },
      {
        title: dataAcf.visaTitle3,
        text: dataAcf.visaText3,
      },
    ];

    let permitCollection = [
      {
        title: dataAcf.permitTitle1,
        text: dataAcf.permitText1,
      },
      {
        title: dataAcf.permitTitle2,
        text: dataAcf.permitText2,
      },
      {
        title: dataAcf.permitTitle3,
        text: dataAcf.permitText3,
      },
      {
        title: dataAcf.permitTitle4,
        text: dataAcf.permitText4,
      },
      {
        title: dataAcf.permitTitle5,
        text: dataAcf.permitText5,
      },
      {
        title: dataAcf.permitTitle6,
        text: dataAcf.permitText6,
      },
    ];

    return (
      <PageBaseLayout
        metaDescription={dataAcf.metaDescription}
        BreadTreeElements={this.state.breadTreeElements}
        heroImgURL={dataAcf.heroImg}
        title={title}
        subTitle={dataAcf.subtitle}
        eyeCatchId={data.featured_media}
        ogLink={data.link}
        bottomSectionText={BottomSectionText.pattern1}
        bottomSectionColor={'#fff'}
        bottomButtonText={buttonText.freeConsulting}
        bottomButtonSize={'23.7rem'}
      >
        <PageDescription>
          <div
            dangerouslySetInnerHTML={{
              __html: dataAcf.pageDescription,
            }}
          />
        </PageDescription>
        <MainSectionDiv>
          <FlexDiv>
            <CollectionDiv>
              <VisaCollectionBox
                category={dataAcf.visaTitle}
                collection={visaCollection}
              />
            </CollectionDiv>
            <CollectionDiv>
              <VisaCollectionBox
                category={dataAcf.permitTitle}
                collection={permitCollection}
              />
            </CollectionDiv>
          </FlexDiv>
        </MainSectionDiv>
      </PageBaseLayout>
    );
  }
}
export default VisaCollection;
